<template>
  <select-vue
    class="select--formless"
    @change="selectInputHandler"
    :name="name"
    :options="options"
    :initial-value="initialValue"
    ref="select"
  />
</template>

<script lang="ts">
  import {Vue, Options, Prop} from 'vue-property-decorator';
  import SelectVue from '../select/select.vue';

  @Options({
    name: 'product-reviews-list-select',
    components: {SelectVue},
  })
  export default class ProductReviewsListSelect extends Vue {
    @Prop({required: true})
    name: string;
    @Prop()
    initialValue: string;
    @Prop({type: Array})
    options: {label: string, value: string}[];
    @Prop({required: true, type: String})
    formId: string;

    selectInputHandler(value) {
      if (value !== this.initialValue) {
        const form = document.getElementById(this.formId) as HTMLFormElement;
        if (form) {
          this.$nextTick(() => {
            form.submit();
          });
        }
      }
    }
  }

</script>
